import StaffPerformanceHTMLPreviewBaseColumnsStrategy from './StaffPerformanceHTMLPreviewBaseColumnsStrategy'

export default function StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy() {}

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype = new StaffPerformanceHTMLPreviewBaseColumnsStrategy()

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype.init = function(timeFormat, groupNameProvider, includeOtherUsersColumn) {
    StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.init.call(this, timeFormat, groupNameProvider)
    this.includeOtherUsersColumn = includeOtherUsersColumn
    return this
}

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype.addFirstHeaderRowCells = function(firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createSpentHeaderCell())
    this.addCell(firstHeaderRow, this.getGroupNameSingular(), "userGroup", 1, 2)
    this.addCell(firstHeaderRow, this.getGroupNameSingular(), "userGroup", 1, 2)
    if (this.includeOtherUsersColumn) this.addCreatedCell(firstHeaderRow, this.createOthersHeaderCell(2))
}

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype.addSecondHeaderRowCells = function(secondHeaderRow) {
    // do nothing
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.js